/**
 * Report element sizing constants
 *
 * Centralized configuration for report element dimensions and validation.
 * Used across dialog components, migrations, and rendering logic.
 */

export const REPORT_ELEMENT_SIZING = {
  /** Default width mode: 'fit' expands to full tab width */
  DEFAULT_WIDTH: 'fit' as const,

  /** Default aspect ratio for new elements */
  DEFAULT_ASPECT_RATIO: '16:9' as const,

  /** Default height in pixels (used when aspectRatio is 'custom') */
  DEFAULT_HEIGHT: 400,

  /** Default custom width in pixels (used when switching from 'fit' to custom) */
  DEFAULT_CUSTOM_WIDTH: 800,

  /** Minimum allowed width in pixels */
  MIN_WIDTH: 200,

  /** Minimum allowed height in pixels */
  MIN_HEIGHT: 200,
} as const;

export type ReportElementWidth = typeof REPORT_ELEMENT_SIZING.DEFAULT_WIDTH | number;
